
























import Vue from 'vue';
import Component from 'vue-class-component';
import { Ref } from 'vue-property-decorator';
import EmployeeList from './EmployeeList.vue';
import UploadFile from '@/components/UploadFile.vue';
import DepartmentAdmin from './DepartmentAdmin.vue';
import { employeeAdminApis } from '@/api/employee_admin.api';
import NewMailAccountDialog from './NewMailAccountDialog.vue';

@Component({ components: { EmployeeList, DepartmentAdmin, UploadFile, NewMailAccountDialog } })
export default class EmployeeAdmin extends Vue {
  @Ref('employee-list') employeeList!: EmployeeList;
  @Ref('upload') uploadFile!: UploadFile;

  activeTab = 'employees';
  treeDialogVisible = false;
  newMailAccountDialogVisible = false;
  companyFilter: number | null = null;

  async syncDingtalk() {
    await employeeAdminApis.syncDingtalk();
    this.$notify.success('钉钉数据同步成功');
    this.employeeList.refresh();
  }

  leading_out() {
    employeeAdminApis
      .leading_out({
        departmentId: this.employeeList.getDepartmentId(),
        name: this.employeeList.getEmployeeSearchName()
      })
      .then(res => this.downloadFile(res, 'excel.xlsx'));
  }

  leading_in() {
    console.info(this.employeeList.getDepartmentId());
    this.uploadFile.show();
  }

  export_perm() {
    return this.employeeList.getDepartmentId();
  }

  downloadFile(res: any, fileName: any) {
    if (!res) {
      return;
    }
    if (window.navigator.msSaveBlob) {
      // IE以及IE内核的浏览器
      try {
        window.navigator.msSaveBlob(res, fileName); // res为接口返回数据，这里请求的时候已经处理了，如果没处理需要在此之前自行处理var data = new Blob([res.data]) 注意这里需要是数组形式的,fileName就是下载之后的文件名 // window.navigator.msSaveOrOpenBlob(res, fileName);  //此方法类似上面的方法，区别可自行百度
      } catch (e) {
        console.log(e);
      }
    } else {
      const url = URL.createObjectURL(new Blob([res]));
      const link = document.createElement('a');
      link.style.display = 'none';
      link.href = url;
      link.setAttribute('download', fileName); // 文件名
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); // 下载完成移除元素
      window.URL.revokeObjectURL(url); // 释放掉blob对象
    }
  }
}
